<template>
  <div>
    <template v-if="sortedResults.length">
      <ul class="list-reset result-list">
        <li
          v-for="(programme, index) in ecoventureChunks[page - 1]"
          :key="programme.objectID"
        >
          <responsive>
            <template #lgmd>
              <loading-item v-if="isLoading" />
              <template v-else>
                <ecoventure-item-large :programme="programme" />
              </template>
            </template>
            <template #sm>
              <loading-item-mobile v-if="isLoading" />
              <ecoventure-item-small v-else :programme="programme" />
            </template>
          </responsive>

          <hr
            class="separator-slim my-10"
            v-if="index !== ecoventureChunks[page - 1].length - 1"
          />
        </li>
      </ul>

      <responsive>
        <template #lg>
          <div class="flex items-center my-10">
            <div class="flex-1">
              <pagination
                @click="onSetPage"
                :pagination-info="paginationInfo"
              />
            </div>

            <div class="flex-none">
              {{ paginationStatus }}
            </div>
          </div>
        </template>
        <template #mdsm>
          <mobile-pagination
            class="sm:px-6"
            :pagination-info="paginationInfo"
          />
        </template>
      </responsive>
    </template>

    <template v-else-if="isLoading">
      <ul class="list-reset lg:mt-24">
        <li v-for="index in 10" :key="index">
          <responsive>
            <template #lgmd>
              <loading-item v-if="isLoading" />
            </template>
            <template #sm>
              <loading-item-mobile v-if="isLoading" />
            </template>
          </responsive>

          <hr class="separator-slim my-10" v-if="index !== 10" />
        </li>
      </ul>
    </template>

    <template v-else-if="hasNoResult">
      <div class="container-sm text-center">
        <h3 class="fs-24 font-medium mb-6">
          We haven’t found any ecoventures matching your criteria.
        </h3>
      </div>

      <speak-with-us class="mt-10" />
    </template>
  </div>
</template>

<script>
import chunk from "lodash/chunk";
import { mapState, mapGetters, mapMutations } from "vuex";

import CustomSelect from "../../components/core/CustomSelect";
import Pagination from "../core/Pagination";
import Responsive from "../core/Responsive";
import EcoventureItemLarge from "./EcoventureItemLarge";
import EcoventureItemSmall from "./EcoventureItemSmall";
import LoadingItem from "./LoadingItem";
import LoadingItemMobile from "./LoadingItemMobile";
import MobilePagination from "./MobilePagination";
import SpeakWithUs from "../../components/Search/SpeakWithUs";
const PER_PAGE = 12;

export default {
  components: {
    LoadingItem,
    LoadingItemMobile,
    EcoventureItemLarge,
    EcoventureItemSmall,
    Responsive,
    Pagination,
    MobilePagination,
    CustomSelect,
    SpeakWithUs,
  },
  data() {
    return {
      sortOptions: [
        { label: "Shortest first", value: "shortest-first" },
        { label: "Longest first", value: "longest-first" },
        { label: "Price", value: "price" },
      ],
    };
  },
  computed: {
    ...mapState(["ranking", "page", "isLoading"]),
    ...mapGetters(["sortedResults"]),
    sortBy: {
      get() {
        return this.ranking;
      },
      set(val) {
        this.setRanking(val);
        this.setPage(1);
      },
    },
    searchSummary() {
      return `<h1 class="inline-block mr-2">Ecoventures: </h1>${this.sortedResults.length} results`;
    },
    ecoventureChunks() {
      return chunk(this.sortedResults, PER_PAGE);
    },
    paginationInfo() {
      return {
        page: this.page,
        per_page: PER_PAGE,
        total: this.sortedResults.length,
      };
    },
    paginationStatus() {
      const { page, per_page, total } = this.paginationInfo;
      const from = (page - 1) * per_page + 1;
      const to = Math.min(page * per_page, total);

      return `Showing ${from} to ${to} of ${total}`;
    },
    hasNoResult() {
      return this.sortedResults.length === 0 && this.isLoading === false;
    },
  },
  mounted() {
    this.$store.dispatch("loadProgrammes");
    this.$store.dispatch("loadStatistics");
  },
  methods: {
    ...mapMutations(["setRanking", "setPage"]),
    onSetPage(p) {
      this.$store.commit("setPage", p);
      document.querySelector(".search-result").scrollIntoView({
        behavior: "smooth",
      });
    },
    handleClearFitlers() {
      this.$store.commit("clearFilters");
      this.$store.dispatch("loadProgrammes");
    },
  },
};
</script>
